import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  CustomInput,
} from 'reactstrap'
import shortid from 'shortid'
import { get } from 'lodash'
import styled from 'styled-components'

class AutoFillManDaysForm extends React.Component {
  generateResourceList() {
    const options = [{ label: '', value: '' }]
    options.push(...get(this.props, 'lobs'))
    options.push(...get(this.props, 'departments'))
    return options
  }
  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <div>
        <Modal isOpen={ get(this.props, 'open') } toggle={ get(this.props, 'cancelForm') }>
          <ModalHeader toggle={ get(this.props, 'cancelForm') }>
            <HeadLabel>Auto Add Resources</HeadLabel>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col sm="12">
                <Form onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col>
                          <TypeLabel >LOB/Department</TypeLabel>
                          {
                            <CustomInputField
                              type="select"
                              id="auto_add_resources_name"
                              name="auto_add_resources_name"
                              value={ get(this.props, 'auto_add_resources_name') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                this.generateResourceList().map((l) => (
                                  <option key={ shortid() } value={ l._id }>{ l.name }</option>)
                                )
                              }
                            </CustomInputField>
                          }
                        </Col>
                      </Row>
                    </Container>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            { get(this.props, 'button') }
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default AutoFillManDaysForm

const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    color: #AD2624;
`
const TypeLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
`

const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/auto-add-resources/index.js